const CONFIG = APP_CONFIG || {};

/**
 * Config module for CMS. It will provide basic configuration for internal services (like API_URL constant).
 *
 * @namespace cms.config
 */
export default angular.module('cms.config', [])
    .constant('CONFIG', CONFIG).name;


// WEBPACK FOOTER //
// ./src/cmsCore/ConfigModule/ConfigModule.js